import {useMemo} from 'preact/hooks';

import {useI18n} from '~/foundation/I18n/hooks';

import {
  AFFIRM_SUPPORTED_LOCALES_BY_COUNTRY_CODE,
  DEFAULT_AFFIRM_SUPPORTED_LOCALE,
} from '../constants';
import {useInstallments} from '../context/InstallmentsContext';
import {getTranslatedLocaleNames} from '../utils/locale';

import {AffirmIcon} from './AffirmIcon';
import {ShopPayIcon} from './ShopPayIcon';

export const InstallmentsModalFooter = () => {
  const {locale, translate} = useI18n();
  const {countryCode = ''} = useInstallments();

  const languageCode = locale?.split('-')[0] ?? DEFAULT_AFFIRM_SUPPORTED_LOCALE;

  const supportedLocales = useMemo(
    () =>
      AFFIRM_SUPPORTED_LOCALES_BY_COUNTRY_CODE[countryCode] ?? [
        DEFAULT_AFFIRM_SUPPORTED_LOCALE,
      ],
    [countryCode],
  );

  const isAffirmSupported = supportedLocales.includes(languageCode);

  const translatedLocaleNames = useMemo(
    () => getTranslatedLocaleNames(languageCode, supportedLocales),
    [languageCode, supportedLocales],
  );

  const affirmLogo = (
    <span className="inline-block">
      <AffirmIcon />
    </span>
  );

  const supportedLanguages = useMemo(
    () =>
      new Intl.ListFormat(locale, {
        type: 'conjunction',
      }).format(translatedLocaleNames),
    [locale, translatedLocaleNames],
  );

  const partnership = translate(
    isAffirmSupported
      ? 'paymentTerms.installmentsModal.partnership'
      : 'paymentTerms.installmentsModal.partnershipDisclaimer',
    {
      affirmLogo,
      supportedLanguages,
    },
  );

  return (
    <footer className="flex flex-col items-center">
      <div className="mb-3 h-5 w-22 text-purple-primary">
        <ShopPayIcon />
      </div>
      <small className="text-caption font-light tracking-wider text-grayscale-d0">
        {partnership}
      </small>
    </footer>
  );
};
